export function arrOfObjsParamValueToLowerCase<T extends Record<string, unknown>>(arr: T[], par: keyof T): T[] {
  return arr.map((obj) => ({
    ...obj,
    [par]: (obj[par] as string).toLowerCase(),
  }));
}
